import { localizationData, defaultLanguage, enabledLanguages, languageCountryAssociations } from '../../../Intl/setup';
import { getUserPreference, setUserPreferenceRequest } from '../User/UserActions';
import { setDateLanguage } from '../../util/date';
import callApi from '../../util/apiCaller';
import { displayErrors } from '../Error/ErrorActions';

// Export Constants
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE';

export function initLanguage(lang = null, user = null, store = null) {
	return dispatch => {
		return new Promise((resolve, reject) => {
			if(!lang) {
				if(store && store.intl && store.intl.isInit) {
					lang = store.intl.locale;
				} else if(global.navigator && global.navigator.language) {
					const navigatorLanguage = global.navigator.language.split('-')[0];
					lang = navigatorLanguage;
				}
				// const initLocale = global.navigator && global.navigator.language || 'en';
			}
			if(enabledLanguages.indexOf(lang) === -1) {
				// console.log('lang not enabled!', lang);
				lang = defaultLanguage;
			}
			return callApi(`intl/language/${lang}`).then(res => {
				if(res) {
					dispatch(switchLanguage(lang, res));
					if(user && lang && localizationData[lang] && lang !== getUserPreference(user, 'language')) {
						dispatch(setUserPreferenceRequest('language', lang));
					}
					// console.log('Lang set', lang);
					resolve(lang);
				}
				return null;
			}).catch(reject);
		});
	};
}

export function translateContentRequest(text, from, to) {
	return callApi('intl/translate', 'post', { text, from, to }).then(result => {
		displayErrors(result.isOk ? (result.confidencePercent > 90 ? 'success' : 'warning') : 'error', `Fiabilité de traduction: ${Math.round(result.confidencePercent)}%`);
		return result;
	}).catch(err => {
		displayErrors('error', err.message || err);
	});
}

export function getEnabledLanguages() {
	return enabledLanguages;
}

export function getCountryFromLanguage(lang) {
	return languageCountryAssociations[lang] || (lang && lang.toUpperCase());
}

export function getTranslation(model, field, lang) {
	if(lang !== 'fr' && model.translations) {
		const translation = model.translations.find(translation => translation.lang === lang);
		if(translation && translation[field]) {
			return translation[field];
		}
	}
	return model[field];
}

export function switchLanguage(newLang, data = null) {
	setDateLanguage(newLang);
	if(newLang && (data || localizationData[newLang])) {
		const messages = (data || localizationData[newLang] || {}).messages || {};
		return {
			type: SWITCH_LANGUAGE,
			locale: newLang,
			messages,
			isInit: true,
		};
	}
	return {
		type: SWITCH_LANGUAGE,
		...localizationData[defaultLanguage],
	};
}
